export default __webpack_public_path__ + "static/media/contact_us.abc14a9b.svg";